import { Box, Typography} from "@mui/material";
import { useSectionData } from "../hooks/useFirebaseData";
import RecommendationsSkeleton from "./ui/RecommendationSkeleton";

function Recommended() {
  const {
    data: recommendedData,
    loading,
  } = useSectionData("recommended", "recommended");

  if (loading) {
    return <RecommendationsSkeleton />;
  }

  const sectionTitle = recommendedData?.recommended_title;
  const recommendationsDescription = recommendedData?.description;
  const subDescription = recommendedData?.sub_description

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
        py:0,
      }}
    >
      <Box sx={{ textAlign: "center", width: "100%" }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            mb: 4,
            color: "#E37503",
            fontSize: { xs: "1.75rem", md: "2rem" },
          }}
        >
          {sectionTitle}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#E87F11",
            lineHeight: 1.6,
            fontSize: { xs: "1.25rem", md: "1.5rem" },
            whiteSpace: "pre-line",
          }}
        >
          {recommendationsDescription}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#E87F11",
            lineHeight: 1.6,
            fontSize: { xs: "1.25rem", md: "1.5rem" },
            whiteSpace: "pre-line",
          }}
        >
          {subDescription}
        </Typography>
      </Box>
    </Box>
  );
}

export default Recommended;
